import React from 'react'
import PropTypes from 'prop-types'

import Button from 'app/components/ButtonDefault'
import ModalBody from 'app/components/Modal/ModalBody'
import ModalTitle from 'app/components/Modal/ModalTitle'
import ModalContent from 'app/components/Modal/ModalContent'

import './styles.scss'

const baseClass = 'protrack-confirmation-modal'

const ProtrackConfirmationModal = ({ t, blockedPathname, formName, onRequestClose, onSave, onForceLeave }) => (
  <ModalBody onRequestClose={onRequestClose}>
    <ModalTitle>{t('You have unsaved changes on this page')}</ModalTitle>
    <ModalContent>{t('Do you want to save your changes before leaving?')}</ModalContent>
    <div className={`${baseClass}__buttons`}>
      <div className={`${baseClass}__buttons-left`}>
        <Button onClick={() => onSave(formName)} primary className={`${baseClass}__button`}>
          {t('common:Save')}
        </Button>
        <Button onClick={onRequestClose} className={`${baseClass}__button`}>
          {t('common:Cancel')}
        </Button>
      </div>
      <Button onClick={() => onForceLeave(blockedPathname)} outline className={`${baseClass}__button`}>
        {t(`common:Don't save`)}
      </Button>
    </div>
  </ModalBody>
)

ProtrackConfirmationModal.propTypes = {
  blockedPathname: PropTypes.string,
  formName: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  onForceLeave: PropTypes.func.isRequired,
}

export default ProtrackConfirmationModal
